import {
  BentoBrand,
  BentoContact,
  NewBentoContact,
  PreviewMessage,
} from "schemas/dashboard";
import { Conditions } from "schemas/outreach";

export type Column = {
  key: string;
  name: string;
};

export type Template = {
  lastUsedAt?: number;
  id?: number;
  createdAt?: number;
  updatedAt?: number;
  name: string;
  subject: string;
  contentType: TemplateContentType;
  body?: string;
  attachment?: string;
  attachedScheduledEmailsCount?: number;
  attachedNichesCount?: number;
  isArchived?: boolean;
  // Use for QuickSend only
  emailTemplateId?: number;
  // Use for OutreachDraft only
  emailTemplateName?: string;
  isAutogenerated?: boolean;
  // Use for onboarding only
  signature?: string;
  agentSessionId?: number;
  // Use for Admin Add On view only
  intakeFormId?: number;
};

export enum MergeTags {
  first_name = '<span data-type="merge-tag" class="merge-tag" data-label="First Name">{First Name}</span>',
  brand_name = '<span data-type="merge-tag" class="merge-tag" data-label="Brand Name">{Brand Name}</span>',
}

export type EmailPreview = {
  bentoBrand: BentoBrand;
  bentoContact: BentoContact;
  bentoContactId?: number;
  outreachMessages: PreviewMessage[];
  contactMethod: string;
  newContact?: NewBentoContact;
  to: string;
};

export enum TemplateContentType {
  OUTREACH = "outreach",
  FOLLOWUP = "followup",
  INBOX = "inbox",
  REPLY = "reply",
}

export enum TemplateMethod {
  from_scratch = "from_scratch",
  use_bento_ai = "use_bento_ai",
}

export enum CreateTemplateStatus {
  SCRATCH = "scratch",
  MAGIC = "magic",
}

export type InstagramSession = {
  username: string;
  reconnectRequired: boolean;
};

export type ConfirmMessage = {
  bentoContactId?: number;
  bentoBrandId?: number;
  subject?: string;
  body?: string;
  contentType: TemplateContentType;
  attachment?: string;
  message?: string;
};

export type TabCountMap = { [key: string]: number };

export type HandleSendEmail = (
  sendAt?: null | string,
  conditions?: Conditions,
  isTest?: boolean,
) => Promise<boolean>;
